import React from "react";
import { useT } from "../i18n/LanguageContext";
import { SectionTag } from "../components/Section";

const SECTIONS = [
  "legal.controller",
  "legal.data",
  "legal.purpose",
  "legal.retention",
  "legal.rights",
  "legal.security",
  "legal.terms",
];

export default function LegalPage() {
  const { t } = useT();
  return (
    <main className="pt-32 md:pt-40" data-testid="page-legal">
      <section className="border-b border-white/10 py-16 md:py-24">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <SectionTag>{t("legal.tag")}</SectionTag>
          <h1 className="mt-6 max-w-3xl font-heading text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {t("legal.title")}
          </h1>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-brand-textDim">{t("legal.intro")}</p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12">
          <div className="grid gap-px border border-white/10 bg-white/5">
            {SECTIONS.map((k, i) => (
              <article key={k} className="bg-brand-bg p-6 sm:p-8">
                <div className="flex items-baseline gap-3">
                  <span className="font-mono text-[10px] tracking-[0.25em] text-brand-textDim">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="font-heading text-xl tracking-tight text-white sm:text-2xl">
                    {t(`${k}_title`)}
                  </h2>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-white/85 sm:text-base">{t(`${k}_body`)}</p>
              </article>
            ))}
          </div>
          <p className="mt-10 text-center font-mono text-[10px] uppercase tracking-[0.22em] text-brand-textDim">
            Last updated · 2026
          </p>
        </div>
      </section>
    </main>
  );
}
